import { InboxView } from '@weave/schema-gen-ts/dist/schemas/sms/data/v4/sms_service.pb';
import { Direction } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { formatPhoneNumberE164 } from '@frontend/phone-numbers';
import { ListThreadsIO } from '../../types';
import { convertSMSStatusToPossibleThreadReadStatus } from './convert-sms-status-to-thread-read-status';

type SMSCouldBeInListThreadsResponseArgs = {
  sms: SMS;
  listThreadsRequest: ListThreadsIO['input'];
};

export const smsCouldBeInListThreadsResponse = ({
  sms,
  listThreadsRequest,
}: SMSCouldBeInListThreadsResponseArgs): boolean => {
  // SMS is deleted
  if (sms.deletedAt || sms.deletedBy) {
    return false;
  }

  // locationIds
  if (listThreadsRequest.locationIds.length && !listThreadsRequest.locationIds.includes(sms.locationId)) {
    return false;
  }

  // filter.departmentIds
  if (
    !!listThreadsRequest.filter?.departmentIds?.length &&
    !listThreadsRequest.filter.departmentIds.includes(sms.departmentId)
  ) {
    return false;
  }

  // filter.personPhones
  if (
    !!listThreadsRequest.filter?.personPhones?.length &&
    !listThreadsRequest.filter.personPhones.some(
      (personPhone) => formatPhoneNumberE164(personPhone) === formatPhoneNumberE164(sms.personPhone)
    )
  ) {
    return false;
  }

  // filter.locationPhones
  if (
    !!listThreadsRequest.filter?.locationPhones?.length &&
    !listThreadsRequest.filter.locationPhones.some(
      (locationPhone) => formatPhoneNumberE164(locationPhone) === formatPhoneNumberE164(sms.locationPhone)
    )
  ) {
    return false;
  }

  // filter.statuses
  const newThreadReadStatuses = convertSMSStatusToPossibleThreadReadStatus({
    status: sms.status,
    direction: sms.direction,
    autogeneratedBy: sms.autogeneratedBy,
  });
  if (
    !!listThreadsRequest.filter?.statuses?.length &&
    !!newThreadReadStatuses &&
    !listThreadsRequest.filter.statuses.some((status) => newThreadReadStatuses.includes(status))
  ) {
    return false;
  }

  // filter.inboxView
  const inboxView = listThreadsRequest.filter?.inboxView ?? InboxView.UNSPECIFIED;
  if (inboxView === InboxView.ACTIONABLE && sms.direction === Direction.DIRECTION_OUTBOUND) {
    return false;
  }

  // filter.excludeAutomatedLastMessage
  if (!!listThreadsRequest.filter?.excludeAutomatedLastMessage && !!sms.autogeneratedBy) {
    return false;
  }

  // filter.personIds
  if (
    !!listThreadsRequest.filter?.personIds?.length &&
    (!sms.personId || !listThreadsRequest.filter.personIds.includes(sms.personId))
  ) {
    return false;
  }

  return true;
};
